import { TextBox } from '@apply/components';
import { IBudgetFixFlip } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetFixFlipField } from '../../../../../queries/useBudgetFixFlipField';

interface WindowsAndDoorsDescriptionProps {
    readOnly?: boolean;
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const WindowsAndDoorsDescription: React.FC<WindowsAndDoorsDescriptionProps> = ({
    required,
    readOnly,
    propertyGuid,
    isReview = false,
}) => {
    const [windowsAndDoors, set_windowsAndDoors] = useBudgetFixFlipField<string>(
        propertyGuid,
        (b) => (b.values?.['Exterior Structure']?.['Windows and Doors']?.[0] as string) ?? '',
        (b, v) => ({ ...b, values: { ...b.values, 'Exterior Structure': { ...b.values?.['Exterior Structure'], 'Windows and Doors': [v, b.values?.['Exterior Structure']?.['Windows and Doors']?.[1] ?? 0] as [string, number] } } })
    );
    const label = 'Description';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={windowsAndDoors}
                />
            ) : (
                <TextBox
                    value={windowsAndDoors}
                    onChange={(value) => set_windowsAndDoors(value)}
                    label={label}
                    required={required}
                    readOnly={readOnly}
                />
            )}
        </>
    );
};
